<style scoped></style>

<template>
  <div class="row mb-3">
    <div class="col-sm-12">
    <div class="input-group  input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Compare To:</span>
      </div>
      <select
        class="form-control"
        :value="comparison"
        @change="changeComparison"
      >
        <option
          v-for="(trendType, index) in trendTypes"
          v-bind:value="trendType.value"
          :key="index"
        >{{ trendType.name }}</option>
      </select>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['comparison'],
  data () {
    return {
      selectedTrend: '',
      trendTypes: [
        { name: 'Last Week', value: 'lastweek' },
        { name: 'Last Month', value: 'lastmonth' },
        { name: 'Last Year', value: 'lastyear' },
        { name: 'Budget', value: 'budget' }
      ]
    }
  },
  methods: {
    changeComparison: function (event) {
      this.$emit('updateComparison', event.target.value)
    }
  }
}
</script>
